var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gh-code-editor',{attrs:{"options":_vm.codeOptions},on:{"submit":_vm.submit,"cancel":_vm.cancel},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})}
var staticRenderFns = []

export { render, staticRenderFns }